var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenSidebar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.542053,
    width: 53.9571,
    height: 50,
    rx: 14,
    fill: "#0B197C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 25.6163L33.9999 25.4675M33.9999 25.4675L25.5705 34.0374M33.9999 25.4675L25.43 17.038",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenSidebar);
export default __webpack_public_path__ + "static/media/open_sidebar.ce2906c3f0fbd6f78bdf1b91407696f3.svg";
export { ForwardRef as ReactComponent };